module.exports = __webpack_public_path__ + "images/xibao_top_semi_backview_2026-2027.1789608252531.jpg";